import { render, staticRenderFns } from "./InfoFilledIcon.vue?vue&type=template&id=a309f6a8&"
import script from "./InfoFilledIcon.vue?vue&type=script&lang=js&"
export * from "./InfoFilledIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports